import { Alert, Box, CircularProgress, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import { LoadingSpinner } from '@verantos-dev/shared-components';
import { borderRadius } from '@verantos-dev/shared-ui-components/tokens';

import { useAgentPromptPreview } from './useAgentPromptPreview';

// TODO: cleanup with cp_annotation_createproject_agent ff

/** The server-rendered prompt for the saved builder configuration. */
export const AgentPromptPreview = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const { prompt, isError, isUpdating } = useAgentPromptPreview();

  return (
    <Box id="agent-prompt-preview">
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(2),
          mb: theme.spacing(4),
        }}
      >
        <Typography variant="subtitle1">
          {formatMessage({ id: 'createProjectWizard.step.annotationAgent.preview.title' })}
        </Typography>
        {isUpdating && prompt !== null && !isError && (
          <CircularProgress
            size={theme.spacing(4)}
            aria-label={formatMessage({
              id: 'createProjectWizard.step.annotationAgent.preview.updating',
            })}
          />
        )}
      </Box>
      {isError ? (
        <Alert severity="error" id="agent-prompt-preview-error">
          {formatMessage({ id: 'createProjectWizard.step.annotationAgent.preview.error' })}
        </Alert>
      ) : prompt === null ? (
        <LoadingSpinner id="agent-prompt-preview" />
      ) : (
        // Rendered verbatim as text, never as markup or Markdown.
        <Box
          component="pre"
          aria-busy={isUpdating}
          sx={{
            m: 0,
            p: theme.spacing(3),
            borderRadius: `${borderRadius.md}px`,
            backgroundColor: theme.palette.grey[100],
            // TODO: no VDS token for this value — needs designer input
            fontFamily: 'monospace',
            fontSize: theme.typography.body2.fontSize,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            // Bounded so the preview, which sticks near the top of the step, ends above the
            // sticky wizard footer on a laptop-height window; longer prompts scroll inside.
            maxHeight: '60vh',
            overflow: 'auto',
          }}
        >
          {prompt}
        </Box>
      )}
    </Box>
  );
};
